import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18745fca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { dsf_title: "Local Notification" }
const _hoisted_2 = { slot: "content" }
const _hoisted_3 = { dsf_gap: "l" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<dsf-option value=\"default\" data-v-18745fca>Default</dsf-option><dsf-option value=\"info\" data-v-18745fca>Info</dsf-option><dsf-option value=\"success\" data-v-18745fca>Success</dsf-option><dsf-option value=\"attention\" data-v-18745fca>Attention</dsf-option><dsf-option value=\"warning\" data-v-18745fca>Warning</dsf-option><dsf-option value=\"error\" data-v-18745fca>Error</dsf-option>", 6)
const _hoisted_10 = [
  _hoisted_4
]
const _hoisted_11 = { dsf_gap: "l" }

import { ref } from 'vue'
import {
  MicrofrontendEvents,
  onDispatchToastNotification,
  publish,
} from '@sennder/senn-node-microfrontend-event-bus'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalNotification',
  setup(__props) {

const category = ref<
  'default' | 'info' | 'success' | 'attention' | 'warning' | 'error'
>('default')
const title = ref('')
const message = ref('')
const icon = ref('')

const onSubmit = () => {
  publish<onDispatchToastNotification>({
    name: MicrofrontendEvents.onDispatchToastNotification,
    data: {
      message: message.value,
      title: title.value || undefined,
      category: category.value,
      icon: icon.value || undefined,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-accordion", _hoisted_1, [
    _createElementVNode("dsf-col", _hoisted_2, [
      _createElementVNode("dsf-row", _hoisted_3, [
        _withDirectives(_createElementVNode("dsf-select", {
          dsf_label: "Category",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category).value = $event))
        }, _hoisted_10, 512 /* NEED_PATCH */), [
          [_vModelText, category.value]
        ]),
        _withDirectives(_createElementVNode("dsf-input", {
          dsf_label: "Title",
          dsf_placeholder: "Title",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, title.value]
        ])
      ]),
      _createElementVNode("dsf-row", _hoisted_11, [
        _withDirectives(_createElementVNode("dsf-input", {
          dsf_label: "Message",
          dsf_placeholder: "Message",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, message.value]
        ]),
        _withDirectives(_createElementVNode("dsf-input", {
          dsf_label: "Icon",
          dsf_placeholder: "Icon",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((icon).value = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, icon.value]
        ])
      ]),
      _createElementVNode("dsf-button", { onClick: onSubmit }, "Dispatch")
    ])
  ]))
}
}

})